module.exports = __webpack_public_path__ + "img/indeed.c3885848.png";